export default "<ion-button (click)=\"presentPopover($event)\">\n\t<ion-icon  slot=\"icon-only\" src=\"/assets/kamps/burger.svg\"></ion-icon>\n</ion-button>\n";